import { render, staticRenderFns } from "./PageContentMobileContentArea.vue?vue&type=template&id=3cd5d798&scoped=true"
import script from "./PageContentMobileContentArea.vue?vue&type=script&lang=js"
export * from "./PageContentMobileContentArea.vue?vue&type=script&lang=js"
import style0 from "./PageContentMobileContentArea.vue?vue&type=style&index=0&id=3cd5d798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5d798",
  null
  
)

export default component.exports